// base
export const ROUTE_BASE_ROOT = '/'; // *WARN: DO NOT change this
export const ROUTE_BASE_NAME = '/'; // *WARN: DO NOT change this
export const ROUTE_WILDCARD = '*';

export const ROUTE_LOGIN = 'login';
export const ROUTE_HOME = 'home';
export const ROUTE_MASTERS ='masters';
export const ROUTE_ADMIN_LOGIN_AS = 'loginAs';

//Division
export const ROUTE_DIVISION ='division';
export const ROUTE_ADD_DIVISION = 'division/adddivision';
export const ROUTE_UPDATE_DIVISION = 'division/:id/edit';

//Brand
export const ROUTE_BRAND ='brand';
export const ROUTE_ADD_NEW = 'brand/addbrand';
export const ROUTE_UPDATE_BRAND = 'brand/:id/edit';

//Job Role
export const ROUTE_JOB_ROLE = 'jobrole';
export const ROUTE_ADD_JOB_ROLE = 'jobrole/addjob';
export const ROUTE_UPDATE_JOB_ROLE = 'jobrole/:id/edit';

//Budget type
export const ROUTE_BUDGET_TYPE = 'budget';
export const ROUTE_ADD_BUDGET_TYPE = 'budget/addbudget';
export const ROUTE_UPDATE_BUDGET_TYPE = 'budget/:id/edit';

//Freeze Allocation
export const ROUTE_FREEZE_ALLOCATION = 'freezeallocation';
export const ROUTE_ADD_FREEZE_ALLOCATION = 'freezeallocation/addfreezeallocation';
export const ROUTE_UPDATE_FREEZE_ALLOCATION = 'freezeallocation/:id/edit';

//Documents
export const ROUTE_DOCUMENTS = 'documents';
export const ROUTE_ADD_DOCUMENTS = 'documents/adddocuments';
export const ROUTE_UPDATE_DOCUMENTS = 'documents/:id/edit';
export const ROUTE_VIEW_DOCUMENTS = 'documents/:id/view';

//Event Configurations
export const ROUTE_EVENT_CONFIGURATION = 'eventConfigurations';
export const ROUTE_ADD_EVENT_CONFIGURATION = 'eventConfigurations/addEventConfigurations';
export const ROUTE_EDIT_EVENT_CONFIGURATION = 'eventConfigurations/:id/edit';
export const ROUTE_VIEW_EVENT_CONFIGURATION = 'eventConfigurations/:id/view';
export const ROUTE_APPROVE_REJECT_EVENT_CONFIGURATION = 'eventConfigurations/:id/approvereject';

//Approval chain definition
export const ROUTE_APPROVAL_CHAIN_DEFINITION_CONFIGURATION = 'approvalChainConfigurations';
export const ROUTE_ADD_APPROVAL_CHAIN_DEFINITION_CONFIGURATION = 'approvalChainConfigurations/addApprovalChainConfigurations';

export const ROUTE_EDIT_APPROVAL_CHAIN_DEFINITION_CONFIGURATION = 'approvalChainConfigurations/:id/edit';

//Uploads
export const ROUTE_UPLOADS = 'upload';
export const ROUTE_PREVIEW_UPLOADS = 'upload/previewupload';

//My Team
export const ROUTE_MY_TEAM = 'myteam';

//My Budget
export const ROUTE_MY_BUDGET = 'mybudget';

//pull back budget
export const ROUTE_PULL_BACK_BUDGET = 'pullBackBudget';

//wallet balance
export const ROUTE_WALLET_BALANCE = 'walletBalance';

//add pull back request
export const ROUTE_ADD_PULL_BACK_BUDGET = 'pullBackBudget/AddPullBackBudget';

//config master
export const CONFIGURATION_MASTER = 'configurationMaster';

//digi document signer configuration
export const ROUTE_DIGI_DOCUMENT_SIGNER_CONFIGURATION = 'digiDocumentSignerConfiguration';
export const ROUTE_ADD_DIGI_DOCUMENT_SIGNER_CONFIGURATION = 'digiDocumentSignerConfiguration/add';
export const ROUTE_EDIT_DIGI_DOCUMENT_SIGNER_CONFIGURATION = 'digiDocumentSignerConfiguration/edit/:id';
export const ROUTE_VIEW_DIGI_DOCUMENT_SIGNER_CONFIGURATION = 'digiDocumentSignerConfiguration/view/:id';

//Request Within Brand
export const ROUTE_REQUEST_WITHIN_BRAND = 'requestwithinbrand';
export const ROUTE_ADD_REQUEST_WITHIN_BRAND = 'requestwithinbrand/addNewRequest';
export const ROUTE_VIEW_REQUEST_WITHIN_BRAND = 'requestwithinbrand/:id/view';

//View Request
export const ROUTE_VIEW_REQUEST = 'viewrequest';
export const ROUTE_EDIT_VIEW_REQUEST = 'viewrequest/:id/edit';

//Reallocate
export const ROUTE_REALLOCATE = 'reallocate';

export const ROUTE_SEARCH_HCP = 'searchhcp';
export const ROUTE_ADD_HCP = 'searchhcp/addhcp';
export const ROUTE_EDIT_HCP = 'searchhcp/:id/edit';
export const ROUTE_VIEW_HCP = 'searchhcp/:id/view';
export const ROUTE_EDIT_HCP_REGISTRATION = 'searchhcp/:id/edithcp';
export const ROUTE_VIEW_HCP_WITH_TAB_PARAM = 'searchhcp/:id/view/:selectedtab';
//Create Events

/*export const ROUTE_CLOSE_EVENT = 'closeevent';
export const ROUTE_VIEW_CLOSE_EVENT = 'closeevent/view';
export const ROUTE_REJECTED_CLOSE_EVENT = 'closeevent/:id/rejected'; */

//Location
export const ROUTE_LOCATION = 'location';
export const ROUTE_ADD_LOCATION = 'location/addlocation';
export const ROUTE_EDIT_LOCATION = 'location/:id/edit';

//User
export const ROUTE_USER = 'user';
export const ROUTE_ADD_USER = 'user/adduser';
export const ROUTE_EDIT_USER = 'user/:id/edit';

//Security Role
export const ROUTE_SECURITY_ROLE = 'securityrole';
export const ROUTE_ADD_SECURITY_ROLE = 'securityrole/addsecurityrole';
export const ROUTE_UPDATE_SECURITY_ROLE = 'securityrole/:id/edit';

//Search Vendor
export const ROUTE_SEARCH_VENDOR = 'searchvendor';
export const ROUTE_ADD_VENDOR = 'searchvendor/addvendor';
export const ROUTE_VIEW_VENDOR = 'searchvendor/:id/view';
export const ROUTE_EDIT_VENDOR = 'searchvendor/:id/edit';
export const ROUTE_UPDATE_VENDOR = 'searchvendor/:id/update';

//Doctor Upload
export const ROUTE_DOCTOR_UPLOAD = 'doctorupload';
//PAYMENT Upload
export const ROUTE_PAYMENT_UPLOAD = 'paymentupload';

//Download Report
export const ROUTE_REPORT_DOWNLOAD = 'reportdownload';

export const ROUTE_CREATE_EVENT = 'createvent';
export const ROUTE_VENDOR_CONFERENCE_EVENT = 'vendorconferenceevent';

export const ROUTE_ADD_EVENT_CREATION = 'createvent/addeventcreation';
export const ROUTE_ADD_VENDOR_CONFERENCE_EVENT = 'vendorconferenceevent/addvendorconferenceevent';

export const ROUTE_VIEW_EVENT_CREATION = 'createvent/:id/view';
export const ROUTE_VIEW_VENDOR_EVENT_CREATION = 'vendorconferenceevent/:id/viewcreate';
export const ROUTE_COMPLETE_VENDOR_EVENT_PLANNING = 'vendorconferenceevent/:id/completeplanning';
export const ROUTE_COMPLETE__CLOSE_VENDOR_EVENT_PLANNING = 'vendorconferenceevent/:id/completeCloseplanning';

//Maps to CloseEvent
export const ROUTE_EDIT_EVENT_CREATION = 'createvent/:id/edit';
export const ROUTE_COMPLETE_EVENT_PLANNING = 'createvent/:id/completeplanning';
export const ROUTE_COMPLETE_CLOSER = 'createvent/:id/completeCloser';
//TODO this io not there

export const ROUTE_APPROVE_REJECT_EVENT_CREATION = 'createvent/:id/approvereject';
export const ROUTE_APPROVE_REJECT_VENDOR_CONFERENCE_EVENT = 'vendorconferenceevent/:id/approvereject';

export const ROUTE_APPROVE_REJECT_EVENT_CLOSURE = 'createvent/:id/approverejectclosure';
export const ROUTE_APPROVE_REJECT_VENDOR_EVENT_CLOSURE = 'vendorconferenceevent/:id/approverejectclosure';

export const ROUTE_RESUBMIT_CLOSURE_EVENT_CREATION = 'createvent/:id/resubmitclosure';
//TODO this io not there
/*export const ROUTE_RESUBMIT_CLOSURE_VENDOR_EVENT_CREATION = 'vendorconferenceevent/:id/resubmitclosur';*/
export const ROUTE_RESUBMIT_CLOSURE_VENDOR_EVENT_CREATION = 'vendorconferenceevent/:id/resubmitclosure';
export const ROUTE_APPROVE_REJECT_EVENT_CLOSURE_FINANCE = 'createvent/:id/approverejectclosurefinance';
export const ROUTE_APPROVE_REJECT_VENDOR_EVENT_CLOSURE_FINANCE = 'vendorconferenceevent/:id/approverejectclosurefinance';

export const ROUTE_APPROVE_REJECT_EVENT_ABORT_REQUEST = 'createvent/:id/approverejectabort';
export const ROUTE_APPROVE_REJECT_VENDOR_EVENT_ABORT_REQUEST = 'vendorconferenceevent/:id/approverejectabort';

export const ROUTE_VALIDATE_EVENT_CREATION_FINANCE = 'createvent/:id/validate';
export const ROUTE_VIEW_VENDOR_EVENT_VALIDATE = 'vendorconferenceevent/:id/validate';

export const ROUTE_UPDATE_ADVANCE_PAYMENT_EVENT_CREATION_FINANCE = 'createvent/:id/updateadvancepayment';
export const ROUTE_UPDATE_ADVANCE_PAYMENT_VENDOR_FINANCE = 'vendorconferenceevent/:id/updateadvancepayment';

export const ROUTE_REPORT_CLOSE_EVENT_CREATION = 'createvent/:id/reportclose';
export const ROUTE_REPORT_CLOSE_VENDOR_EVENT_CREATION = 'vendorconferenceevent/:id/reportclose';

export const ROUTE_EDIT_VENDOR_EVENT_CREATION = 'vendorconferenceevent/:id/resubmitcreate';
//TODO this is not there

export const ROUTE_SERVICE_AGREEMENT_UPLOAD = 'serviceagreement';

export const ROUTE_PASSBOOK ='passbook';

// SCOPE
export const ROUTE_CREATE_SCOPE = 'scope';

export const ROUTE_ADD_SCOPE_CREATION = 'scope/addscope';

export const ROUTE_RESUBMIT_SCOPE_CREATION = 'scope/:id/resubmit';

export const ROUTE_APPROVE_REJECT_SCOPE_CREATION = 'scope/:id/approvereject';
export const ROUTE_VIEW_SCOPE_CREATION = 'scope/:id/view';
export const ROUTE_EDIT_SCOPE_CREATION = 'scope/:id/edit';

//TEMPLATE MASTER
export const ROUTE_TEMPLATE_MASTER = 'template';
export const ROUTE_ADD_TEMPLATE = 'template/add';
export const ROUTE_VIEW_TEMPLATE = 'template/view/:id';
export const ROUTE_EDIT_TEMPLATE = 'template/edit/:id';

//CANCELLATION REASON

export const ROUTE_CANCELLATION_REASON = 'cancellationReason';
export const ROUTE_EDIT_CANCELLATION_REASON = 'cancellationReason/edit/:id';
export const ROUTE_ADD_CANCELLATION_REASON = 'cancellationReason/add';

//EVENT APPROVAL AMOUNT CONFIG
export const ROUTE_EVENT_APPROVAL_AMOUNT_CONFIG = 'eventApprovalAmountConfig';
export const ROUTE_ADD_EVENT_APPROVAL_AMOUNT_CONFIG = 'eventApprovalAmountConfig/add';
export const ROUTE_EDIT_EVENT_APPROVAL_AMOUNT_CONFIG = 'eventApprovalAmountConfig/edit/:id';

//KOL
export const ROUTE_KOL = 'kolevent';
export const ROUTE_CREATE_SCOPE_EVENT = 'kolevent/createscopeevent';
export const ROUTE_VIEW_KOL_EVENT = 'kolevent/:id/view';
export const ROUTE_APPROVE_REJECT_KOL_CREATION = 'kolevent/:id/approvereject';
export const ROUTE_RESUBMIT_KOL_CREATION = 'kolevent/:id/resubmit';
export const ROUTE_UPDATE_ADVANCED_PAYMENT_KOL_EVENT = 'kolevent/:id/updateadvancepayment';
export const ROUTE_VIEW_KOL_EVENT_SCOPES = 'kolevent/:id/viewscope';
export const ROUTE_KOL_SCOPE_CLOSURE = 'kolscope/:id/kolscopereportclose';
export const ROUTE_VIEW_KOL_SCOPE = 'kolscope/:id/view';
export const ROUTE_RESUBMIT_KOL_SCOPE = 'kolscope/:id/resubmit';
export const ROUTE_APPROVE_KOL_SCOPE_BY_FT = 'kolscope/:id/approverejectbyft';

//EXCEPTION REPORTING
export const ROUTE_EXCEPTION_REPORTS = 'exceptionExpenses';
export const ROUTE_ADD_EXCEPTION_REPORTS = 'exceptionExpenses/add';
export const ROUTE_VIEW_EXCEPTION_REPORTS = 'exceptionExpenses/:id/view';

//EVENT SIGNER
export const ROUTE_EVENT_SIGNER = 'eventSignerConfiguration';

export const ROUTE_UPDATE_DOCTOR_ERP_CODE = 'updateErpCodeForDoctor';

// Balance Report

export const ROUTE_BALANCE_REPORT = 'balanceReport';

// HelpSection

export const ROUTE_HELP_SECTION = 'helpSection';
export const ROUTE_ADD_HELP_SECTION = 'helpSection/addhelpsection';
export const ROUTE_EDIT_HELP_SECTION = 'helpSection/:id/edit';
export const ROUTE_VIEW_HELP_SECTION = 'helpSection/:id/view';
export const ROUTE_VIEW_USER_HELP_SECTION = 'helpSection/:id/viewhelpsection';
export const ROUTE_VIEW_USER_HELP_SECTION_DOCUMENT = 'helpSection/:id/viewhelpsection/:id/document';

//sync log report
export const ROUTE_SYNC_LOG_REPORT = 'synclogreport';
export const ROUTE_SYNC_LOG_DETAIL_REPORT = 'synclogreport/:id/:logType/viewLogDetails';

// PurchaseRequisition
export const ROUTE_PR_HEADER = 'prheader';
export const ROUTE_ADD_PR_HEADER = 'prheader/addprheader';
export const ROUTE_VIEW_PR = 'prheader/:id/view';

export const ROUTE_APPROVE_REJECT_PR = 'prheader/:id/action/:action';
export const ROUTE_EDIT_PR = 'prheader/:id/edit';
export const ROUTE_ADD_PO = 'prheader/:id/view/addpo';
export const ROUTE_MANAGE_PURCHASE_ORDER = 'purchaseorder';
export const ROUTE_MANAGE_GOODS_RECEIPT = 'grn';
export const ROUTE_ADD_GRN = 'grn/addgrn';
export const ROUTE_EDIT_PO = 'purchaseorder/:id/editpo';
export const ROUTE_VIEW_PO_LINE_ITEM = 'purchaseorder/:id/view';
export const ROUTE_APPROVE_REJECT_PO_LINE_ITEM = 'purchaseorder/:id/action/:action';
export const ROUTE_RESUBMIT_PO_LINE_ITEM = 'purchaseorder/:id/view/resubmit';
export const ROUTE_ADD_PURCHASE_ORDER = 'purchaseorder/:poId/editpo/:prId/addpo';
export const ROUTE_TRANSACTION_DETAILS = 'prheader/:id/transactiondetails';

// PRApprovalConfig
export const ROUTE_PR_APPROVAL_CONFIG = 'prApprovalConfig';
export const ROUTE_ADD_PR_APPROVAL_CONFIG = 'prApprovalConfig/addPRApprovalConfig';
export const ROUTE_EDIT_PR_APPROVAL_CONFIG = 'prApprovalConfig/:id/editPRApprovalConfig';
